import { useI18n } from "@common/hooks/i18n";
import classnames from "classnames";
import React from "react";
import "./style.less";

export interface ShowMoreListProps {
  className?: string;
  items: string[];
  itemCount?: number;
}
export const ShowMoreList = ({ itemCount = 4, ...props }: ShowMoreListProps) => {
  const i18n = useI18n();

  const [isCollapsed, setIsCollapsed] = React.useState<boolean>(true);

  if (!props.items.length) return null;

  return (
    <div className={classnames("wsc_show_more_list", props.className)}>
      <ul className="list">
        {(isCollapsed ? props.items.slice(0, itemCount) : props.items).map((x, i) => (
          <li key={i} className="item">
            &minus;&nbsp;{x}
          </li>
        ))}
      </ul>

      {props.items.length > itemCount && (
        <div
          className={classnames("action_link", { collapsed: isCollapsed })}
          onClick={(e) => {
            e.stopPropagation();
            setIsCollapsed(!isCollapsed);
          }}
        >
          {isCollapsed ? i18n.showMore : i18n.showLess}
        </div>
      )}
    </div>
  );
};
